__turbopack_context__.v({
  "className": "lilita_one_629d9d12-module__8BXDOq__className",
});
